<template>
  <div class="container mt-4">
    <h2 class="text-center mb-4 text-neon">太空工程师 - 里世界</h2>
    <div class="card bg-dark text-white mb-4 shadow-neon">
      <div class="card-body">
        <h5 class="card-title text-neon">常用命令</h5>
        <ul class="list-unstyled">
          <li>!h save 泊船</li>
          <li>!h load [序号] 提船</li>
          <li>!h list 查看船坞</li>
          <li>!blocklimit mylimit 查看限制</li>
          <li>!grids list 列出本星区所有网格，并添加GPS</li>
          <li>!fixship 修复网格的一些奇怪问题</li>
          <li>!nexus lobby 回到大唐大厅</li>
          <li>!lag profile 检查自己的网格是否卡服</li>
        </ul>
      </div>
    </div>
    <div class="card bg-dark text-white mb-4 shadow-neon">
      <div class="card-body">
        <h5 class="card-title text-neon">网格限制</h5>
        <p>单网格最大网格数不可超过6000</p>
        <p>单网格最大PCU不得超过4w</p>
        <p>单人放入世界总PCU: 15w</p>
        <p>(放入船坞的不计数, 所以暂时不用的船请放船坞)</p>
        <p>其他具体方块限制请使用命令查看: !blocklimit mylimit</p>
        <p>近期发现很多工程师通过链接和合并实现超限，腐竹和管理人员理解大建的乐趣，但是由于服务器性能限制，这样的方式不能继续扩大。这类的建筑会受到船坞，捞船的限制。后续插件的设置更改也可能导致这类网格直接被系统删除。拥有超限网格的工程师请及时分割或拆除回收材料以避免损失。届时起，这类网格出现得任何问题也都不会收到任何支持。</p>
      </div>
    </div>
    <div class="card bg-dark text-white mb-4 shadow-neon">
      <div class="card-body">
        <h5 class="card-title text-neon">威胁等级及海盗刷新</h5>
        <p>以下是每个网格的威胁评分计算的详细概述：</p>
        <ul class="list-unstyled">
          <li>损坏、不完整的方块将被跳过。</li>
          <li>计算器将统计网格上的总方块数，每100个方块增加1分。</li>
          <li>开启的电力设备每提供10兆瓦的电力，方块的威胁评分将增加1点。</li>
        </ul>
        <p>方块及其点数值的表格：</p>
        <ul class="list-unstyled">
          <li>纳米机器人建造与修复（小型和大型）：10分</li>
          <li>纳米控制工厂：15分</li>
          <li>能量盾牌（小网格/小型）：3分</li>
          <li>能量盾牌（小网格/大型）：7分</li>
          <li>能量盾牌（大网格/小型）：10分</li>
          <li>能量盾牌（大网格/大型）：20分</li>
          <li>防御盾牌（小网格）：7分</li>
          <li>防御盾牌（大网格）：10分</li>
          <li>防御盾牌（站台网格）：20分</li>
          <li>武器：5分</li>
          <li>生产：1.5分</li>
          <li>工具方块：1分</li>
          <li>推进器：1分</li>
          <li>货物：0.5分</li>
          <li>天线：4分</li>
          <li>信标：3分</li>
        </ul>
        <p>*小网格总分将被除以二；大型网格，总分则乘以2.5。</p>
        <p>然后计算玩家坐标5km半径内所有网格的总分，如果分数满足海盗等级要求，则会刷出相应的海盗。</p>
        <p>每人遭遇海盗有冷却时间10分钟。每个30km半径区域限制最多两个海盗刷新。</p>
        <h6 class="text-neon">海盗威胁等级对照</h6>
        <h6 class="text-neon">生活区</h6>
        <ul class="list-unstyled">
          <li>LV02 - 600</li>
          <li>LV07 - 1000</li>
          <li>LV08 - 1100</li>
          <li>LV10 - 1800</li>
        </ul>
        <h6 class="text-neon">深空区</h6>
        <ul class="list-unstyled">
          <li>LV10 - 1000</li>
          <li>LV20 - 1500</li>
          <li>LV30 - 2000</li>
          <li>LV40 - 2500</li>
          <li>LV50 - 3000</li>
          <li>LV60 - 6000</li>
        </ul>
        <h6 class="text-neon">矿区</h6>
        <ul class="list-unstyled">
          <li>LV20 - 1500</li>
          <li>LV30 - 1700</li>
          <li>LV40 - 2000</li>
          <li>LV50 - 2300</li>
          <li>LV60 - 6000</li>
          <li>LV70 - 8000</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home'
};
</script>

<style scoped>
  .container {
    max-width: 960px;
  }
  .card {
    background-color: #1a1a1a66 !important;
    border: none;
    margin-bottom: 20px;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }
  .card-body {
    color: #f0f0f0;
    padding: 20px;
  }
  h5, h6 {
    color: #00e0ff;
    font-weight: bold;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    margin-bottom: 5px;
  }
  .text-neon {
    color: #00e0ff;
    text-shadow: 0 0 2px rgba(0, 224, 255, 0.5);
  }
  .shadow-neon {
    box-shadow: 0 0 3px rgba(0, 224, 255, 0.5);
  }
</style>
